import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=00b1b3b8&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=00b1b3b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b1b3b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00b1b3b8')) {
      api.createRecord('00b1b3b8', component.options)
    } else {
      api.reload('00b1b3b8', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=00b1b3b8&scoped=true&", function () {
      api.rerender('00b1b3b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2q5k2RPyiYcYB/JS/comp/DateRange.vue"
export default component.exports